var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileEportal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 2.75C5.8078 2.75 5.5 3.0578 5.5 3.4375C5.5 3.8172 5.8078 4.125 6.1875 4.125H10.3125C10.6922 4.125 11 3.8172 11 3.4375C11 3.0578 10.6922 2.75 10.3125 2.75H6.1875Z",
    fill: "#5C5E69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 11C12.375 13.2782 10.5282 15.125 8.25 15.125C5.97183 15.125 4.125 13.2782 4.125 11C4.125 8.72183 5.97183 6.875 8.25 6.875C10.5282 6.875 12.375 8.72183 12.375 11Z",
    fill: "#5C5E69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4375 0C1.53902 0 0 1.53902 0 3.4375V19.25C0 20.7688 1.23122 22 2.75 22H13.75C15.2688 22 16.5 20.7688 16.5 19.25V3.4375C16.5 1.53902 14.961 0 13.0625 0H3.4375ZM1.375 3.4375C1.375 2.29841 2.29841 1.375 3.4375 1.375H13.0625C14.2016 1.375 15.125 2.29841 15.125 3.4375V18.2806C14.8709 18.0738 14.5226 17.8364 14.0575 17.6038C12.9141 17.0321 11.0863 16.5 8.25 16.5C5.41365 16.5 3.58595 17.0321 2.44254 17.6038C1.9774 17.8364 1.62906 18.0738 1.375 18.2806V3.4375Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEportal);
export default __webpack_public_path__ + "static/media/Profile-eportal.ccae7688244610c9104c10cc3dbd8683.svg";
export { ForwardRef as ReactComponent };